// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import logger from "./logService";

import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";

import { useAuthState } from "react-firebase-hooks/auth";

import siteSettings from "../config/site-settings";
import logService from "./logService";
import httpService from "./httpService";

const firebaseConfig = {
  apiKey: "AIzaSyCLS6IzKd9VR1zq9AsBk_qNwKEZw_Ek01k",
  authDomain: "showslike.firebaseapp.com",
  projectId: "showslike",
  storageBucket: "showslike.appspot.com",
  messagingSenderId: "591962203227",
  appId: "1:591962203227:web:6934dda0a5676b1f1f4b7e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const tokenKey = 'showslike-token';

const apiEndpoint = siteSettings.apiUrl + "/auth"

onAuthStateChanged(auth, (user) => {
  logger.log("onAuthStateChanged!!!")
  if (user) {

    // User is signed in, see docs for a list of available properties
    // https://firebase.google.com/docs/reference/js/firebase.User
    refreshToken()
    // ...
  } else {
    // User is signed out
    user = false
  }
});

const login = async ( user ) => {
  try {
    logger.log("authService.login")
    let { email, password } = user
    let result = await signInWithEmailAndPassword(auth, email, password);
    saveUserToken( result )

    return {result,undefined};
  } catch (err) {
    logService.log(err)
    if( err.code && 'auth/user-not-found' === err.code ) {
      err.message = "User not found."
    } else if( 'auth/wrong-password' === err.code ) {
      err.message = "Login failed."
    }
    return {undefined,err};
  }
};

const loginWithGoogle = async () => {
  try{
    logger.log("authService.loginWithGoogle")
    let result = await signInWithPopup(auth, new GoogleAuthProvider());
    saveUserToken( result )
    return result;
  } catch (err) {
    logService.log(err)
  }
}

const saveUserToken = result => {
  logger.log("authService.saveUserToken")
  if( result && result.user && result.user.accessToken ){
    localStorage.setItem( tokenKey, result.user.accessToken );
  }
}

/*const getUserToken = () => {
  logger.log("authService.getUserToken")
  let userAccessToken = localStorage.getItem( tokenKey );
  return userAccessToken;
}*/

export function useAuth(){
  // logger.log("authService.useAuth")
  return useAuthState(auth)
}

export function register(user) {
  logger.log("authService.register")
  return httpService.post(apiEndpoint + '/register', {
    displayName: user.displayName,
    email: user.email,
    password: user.password,
  })
}

export async function getAppUser( user ) {
  logger.log("authService.getAppUser")
  if(!user || !user.uid) return null;
  let result;
  try{
    result = await httpService.get( siteSettings.apiUrl + "/users/" + user.uid )
  } catch (err) {
    // todo: can't get app user!
    logger.log("appUser fetch error:", err)
  }

  if(!result) return null
  return result.data
}

const logout = async () => {
  logger.log("authService.logout")
  localStorage.removeItem( tokenKey );
  return signOut(auth);
};

const resetPassword = async ( email ) => {
  logger.log("authService.resetPassword");
  let result = await sendPasswordResetEmail( auth, email )
    .then(() => {
      return [true,false];
    })
    .catch((err) => {
      return [false,err];
    });

  return result;
}

export async function refreshToken(){
  logger.log("authService.refreshToken")
  let userToken = await auth.currentUser.getIdToken(true);
  if(userToken){
    localStorage.setItem( tokenKey, userToken );
  }
}

export async function getAuthHeader(){

  const localUserToken = localStorage.getItem( tokenKey );

  if( localUserToken ){
    return 'Bearer ' + localUserToken
  }

  if( !localUserToken && auth && auth.currentUser ){
    console.log("getting user token..")
    let userToken = await auth.currentUser.getIdToken(true); // getUserToken()

    if(!userToken && auth && auth.currentUser){
      console.log("refreshing token..")
      refreshToken()
    }

    return 'Bearer ' + userToken
  } else {
    return false
  }
}

const authService = {
  auth,
  login,
  loginWithGoogle,
  logout,
  onAuthStateChanged,
  useAuth,
  register,
  resetPassword,
  getAuthHeader,
  getAppUser,
};

export default authService;

